<div  class="container ">
    <div class="row  d-flex justify-content-center h-100">
        <div class="card col-md-12 h-100 p-0">
            <div class="card-header w-100">
                <h3 class=" text-center">Recuperar contraseña</h3>
            </div>
            <div class="card-body">
                <form *ngIf="operacion === 'CORREO'" [formGroup]="forma_correo" (ngSubmit)="correoRecuperar()">
                    <div  class="col-auto py-1">
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                                <mat-icon color="primary">{{hide ? 'email' : 'email'}}</mat-icon>
                            </div>
                          </div>
                          <input type="text" class="form-control" id="inlineFormInputGroup" formControlName="des_correo" placeholder="Correo">
                        </div>
                    </div>
                    <div class="col-auto py-1">
                        <button [disabled]="forma_correo.invalid" type="submit" class="btn bg-primary form-control text-white" >Enviar</button>
                    </div>
                </form>
                <form *ngIf="operacion === 'CODIGO'" [formGroup]="forma_codigo" (ngSubmit)="confirmarCodigo()">
                    <div  class="col-auto py-1">
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                                <mat-icon color="primary">{{hide ? 'widgets' : 'widgets'}}</mat-icon>
                            </div>
                          </div>
                          <input type="text" class="form-control" id="inlineFormInputGroup" formControlName="des_codigo" placeholder="Codigo">
                        </div>
                    </div>
                    <div class="col-auto py-1">
                        <button [disabled]="forma_codigo.invalid" type="submit" class="btn bg-primary form-control text-white" >Aceptar</button>
                    </div>
                </form>
                <form *ngIf="operacion === 'PASS'" [formGroup]="forma_pass" (ngSubmit)="cambiarPass()">
                    <div  class="col-auto py-1">
                        <label class="sr-only" for="inlineFormInputGroup">Contraseña</label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text" style="cursor: pointer;" (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                <mat-icon color="primary">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </div>
                          </div>
                          <input [type]="hide ? 'password' : 'text'" class="form-control" id="inlineFormInputGroup" formControlName="pass_usuario" placeholder="Contraseña">
                        </div>
                      </div>
                      <div class="col-auto py-1">
                        <button [disabled]="forma_pass.invalid" type="submit" class="btn bg-primary form-control text-white" >Enviar</button>
                    </div>
                </form>
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <button (click)="cerrarmodal()"  class="btn text-white bg-danger mr-2" >Volver</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
